import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { loadQuoteEpic } from './loadQuoteEpic';

export const quoteLoadingEpic = () => {
  return combineEpics(withAppCrashIfException('quoteLoading', loadQuoteEpic()));
};
